import { Component, Input, OnInit } from "@angular/core";
import { SerieType } from "../../../../../arch/domain/entity/serie.entity";

@Component({
    selector: "app-period-comparation-progress",
    imports: [],
    standalone: true,
    templateUrl: "./period-comparation-progress.component.html",
    styleUrl: "./period-comparation-progress.component.scss"
})
export class PeriodComparationProgressComponent implements OnInit {
    @Input() series: SerieType[];

    ngOnInit(): void {}
}

export interface PeriodComparationData {
    series: SerieType[];
}
